import React from 'react';

import { isMobileScreen } from '../../../services';
import getWidthContext from '../../../HOCs/getWidthContext';
import ListSavedSearchMobile from './ListSavedSearchMobile';
import ListSavedSearchWeb from './ListSavedSearchWeb';

const ListSavedSearch = (props) => {
  if (isMobileScreen(props.width)) {
    // show mobile page
    return <ListSavedSearchMobile {...props} />;
  }

  // show web page
  return <ListSavedSearchWeb {...props} />;
};

export default getWidthContext(ListSavedSearch);



// WEBPACK FOOTER //
// ./src/containers/SavedSearchPage/ListSavedSearch/index.tsx